import { render, staticRenderFns } from "./ProductHeaderGallery.vue?vue&type=template&id=4087a137"
import script from "./ProductHeaderGallery.vue?vue&type=script&lang=js"
export * from "./ProductHeaderGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductHeaderGallery.vue?vue&type=style&index=0&id=4087a137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports